import { SEND_REMINDER_START, SEND_REMINDER_FAILURE, SEND_REMINDER_SUCCESS, RESET_SENT_EMAILS } from '../actions/types';

const defaultState = {
  sendingEmails: false,
  sentEmails: false,
};

export default function emailReminderReducers(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case SEND_REMINDER_START:
    case SEND_REMINDER_FAILURE:
    case SEND_REMINDER_SUCCESS:
    case RESET_SENT_EMAILS: {
      return {
        ...state,
        ...payload,
      };
    }

    default: {
      return state;
    }
  }
}
